import { IntegrationTypeCardView } from '../view/IntegrationTypeCardView';
import { templateIntegrationTypeCard } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { IntegrationTypeCardWebComponent } from '..';
import { IntegrationTypeCardWebComponentSchema } from '../types';
import { ButtonEvents } from '../../../ui/gzButton/types';
import { CreateIntegrationEvent } from '../../addIntegrationPanel/types/CreateIntegrationEvent';
import { IntegrationType } from '../../types/integration-type';

export class IntegrationTypeCardController extends BaseWebComponentController {
  public component: IntegrationTypeCardWebComponent;
  public view: IntegrationTypeCardView;
  public viewConstructor: typeof IntegrationTypeCardView;

  constructor(component: IntegrationTypeCardWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrationTypeCardView,
      viewTemplate: templateIntegrationTypeCard,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$integrateButton,
        event: ButtonEvents.CLICK,
        callback: this.handleIntegrateButtonClick,
      },
      {
        element: this.view.dom.$requirementsButton,
        event: ButtonEvents.CLICK,
        callback: this.handleRequirementsButtonClick,
      },
      {
        element: this.view.dom.$addLicenseButton,
        event: ButtonEvents.CLICK,
        callback: this.handleAddLicenseButtonClick,
      },
    ];
  }

  async getDataForView(): Promise<IntegrationTypeCardWebComponentSchema> {
    return {
      description: this.component.description,
      type: this.component.type,
      license: this.component.license,
      name: this.component.name,
      nonUserConfigurable: this.component.nonUserConfigurable,
      integrationType: this.component.integrationType,
    };
  }

  handleIntegrateButtonClick() {
    this.component.dispatchEvent(
      new CustomEvent(CreateIntegrationEvent.OnShowRequirements, {
        detail: {
          type: this.component.type,
          nonUserConfigurable: this.component.nonUserConfigurable,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  handleRequirementsButtonClick() {
    this.component.dispatchEvent(
      new CustomEvent(CreateIntegrationEvent.OnShowInformationAboutIntegration, {
        detail: {
          type: this.component.type,
          nonUserConfigurable: this.component.nonUserConfigurable,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  handleAddLicenseButtonClick() {
    this.component.dispatchEvent(
      new CustomEvent(CreateIntegrationEvent.OnLicenseAdd, {
        bubbles: true,
        composed: true,
      })
    );
  }
}
